import { useDispatch } from "react-redux";
import Button from "@shared/v2/Button";
import { setConferenceCallParams } from "../../reducers/dialerReducer/dialerReducer";

const ConferenceCallButton = () => {
  const dispatch = useDispatch();

  const launchConfirmModal = () => {
    const rows = document.querySelectorAll(
      "table.leads-table tr input:checked, table.all-people-table tr input:checked",
    );
    const leadUuids = [];
    Array.from(rows).forEach((i) => {
      const { personUuid } = i.closest("tr").dataset;
      if (personUuid) leadUuids.push(personUuid);
    });

    dispatch(
      setConferenceCallParams({
        leadUuids,
        callSource: "Lead Index Brivity Dialer",
      }),
    );
  };

  return (
    <Button size="medium" onClick={launchConfirmModal}>
      Call
    </Button>
  );
};

export default ConferenceCallButton;
